import React from "react";
import ReactDOM from "react-dom/client";
import Routers from "./Routers";
import AppProviders from "./AppProviders";
import { registerServiceWorker } from "./registerServiceWorker";
import "./i18n/i18n";
import "./app.css";
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary";
import { initClarity } from "./analytics/clarity";

registerServiceWorker();
initClarity();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <AppProviders>
      <Routers />
    </AppProviders>
  </ErrorBoundary>
);
